module.exports = __webpack_public_path__ + "static/media/11.23c2d035.jpg";